import Controller from '../abstracts/Controller';
import 'scss-templates/t-pdp.scss';

export default class PdpController extends Controller {
  static get COMPONENTS() {
    return [
      'CarouselComponent',
      'SizeSelectorComponent',
      'PdpMainComponent',
      'PdpImagesComponent',
      'SkuInfoAccordionComponent',
      'CompleteLookComponent',
      'AddToCartComponent',
      'NotifyMeComponent',
      'WishlistComponent',
      'RecommendationEngineComponent',
      'GoogleRecommendationEngineComponent',
      'EditorialCoverInfiniteComponent',
      'JournalComponent',
      'LookbookComponent',
      'StoreEventComponent',
      //giftcard component
      'PdpGiftCardComponent',
    ];
  }

  //the only way to preload only some module is to define import statically
  static get PRELOAD_MAP() {
    return {
      PdpImagesComponent: () => {
        return import(
          /* webpackPreload: true */
          /* webpackChunkName: "component-PdpImagesComponent" */
          "../components/PdpImagesComponent"
          )
      },
      PdpMainComponent: () => {
        return import(
          /* webpackPreload: true */
          /* webpackChunkName: "component-PdpMainComponent" */
          "../components/PdpMainComponent"
          )
      },
      AddToCartComponent: () => {
        return import(
          /* webpackPreload: true */
          /* webpackChunkName: "component-AddToCartComponent" */
          "../components/AddToCartComponent"
          )
      },
      CarouselComponent: () => {
        return import(
          /* webpackPreload: true */
          /* webpackChunkName: "component-CarouselComponent" */
          "../components/CarouselComponent"
          )
      },
      NotifyMeComponent: () => {
        return import(
          /* webpackPreload: true */
          /* webpackChunkName: "component-NotifyMeComponent" */
          "../components/NotifyMeComponent"
          )
      }
    }
  };
}
